// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Popup_overlay___BKue","popup":"Popup_popup__GNPXq"};